
import React from 'react';
import { api } from '../api';
import { connect } from 'react-redux';
import { message, Table, Form, Input, Row, Col, Modal, Divider, Button, PageHeader, Breadcrumb, Menu, Dropdown } from 'antd';
import queryString from 'query-string';
import moment from 'moment';
import QueueAnim from 'rc-queue-anim';
import { utils } from 'utils';
const FormItem = Form.Item;
class Detalle extends React.Component {

    state = {
        disabledLogin: false,
        confirmLoading: false,
        current: 0,
        flag: true,
        apagar: 0,
        data1: [],
        cheques_propios: [],
        cheques_terceros: [],
        CONCEPTOS_VALES: Object.freeze({
            CHEQUESPROPIOS: "14",
            CHEQUESTERCEROS: "13",
        }),
        columnsC: [
            {
                title: 'Hecho el',
                dataIndex: 'feemi_cp',
                // sorter: true,
                key: 'feemi_cp',
                width: 100,
                // render:(col,row)=>
            },
            {
                title: 'Cobrar el',
                dataIndex: 'fecobro_cp',
                // sorter: true,
                key: 'fecobro_cp',
                width: 100,
                // render:(col,row)=>
            },
            {
                title: 'Banco',
                dataIndex: 'nombco_cp',
                // sorter: true,
                key: 'nombco_cp',
                width: 100,
                // render:(col,row)=>
            },
            {
                title: 'N° Cuenta',
                dataIndex: 'nucta_cp',
                // sorter: true,
                key: 'nucta_cp',
                width: 100,
                // render:(col,row)=>
            },
            {
                title: 'N° Serie',
                dataIndex: 'nuseri_cp',
                // sorter: true,
                key: 'nuseri_cp',
                width: 100,
                // render:(col,row)=>
            },
            {
                title: 'N° Cheque',
                dataIndex: 'numero_cp',
                // sorter: true,
                key: 'numero_cp',
                width: 100,
                // render:(col,row)=>
            },
            {
                title: 'CUIT Emisor',
                dataIndex: 'cuitemi_cp',
                // sorter: true,
                key: 'cuitemi_cp',
                width: 100,
                // render:(col,row)=>
            },
            {
                title: 'Entregado a',
                dataIndex: 'nprovee_cp',
                // sorter: true,
                key: 'nprovee_cp',
                width: 100,
                // render:(col,row)=>
            },
            {
                title: 'Importe',
                dataIndex: 'importe_cp',
                // sorter: true,
                key: 'importe_cp',
                width: 100,
                align: 'right',
                render: (col, row) => `${utils.currency(row.importe_cp)}`,
            }
        ],
        columnsCT: [
            {
                title: 'Hecho el',
                dataIndex: 'feemi_ct',
                key: 'feemi_ct',
                width: 100,
            },
            {
                title: 'Cobrar el',
                dataIndex: 'fecobro_ct',
                key: 'fecobro_ct',
                width: 100,
            },
            {
                title: 'Banco',
                dataIndex: 'nombco_ct',
                key: 'nombco_ct',
                width: 100,
            },
            {
                title: 'N° Cuenta',
                dataIndex: 'nucta_ct',
                key: 'nucta_ct',
                width: 100,
            },
            {
                title: 'N° Serie',
                dataIndex: 'nuseri_ct',
                key: 'nuseri_ct',
                width: 100,
            },
            {
                title: 'N° Cheque',
                dataIndex: 'numero_ct',
                key: 'numero_ct',
                width: 100,
            },
            {
                title: 'CUIT Emisor',
                dataIndex: 'cuitemi_ct',
                key: 'cuitemi_ct',
                width: 100,
            },
            {
                title: 'A la orden',
                dataIndex: 'destina_ct',
                key: 'destina_ct',
                width: 100,
            },
            {
                title: 'Importe',
                dataIndex: 'importe_ct',
                key: 'importe_ct',
                width: 100,
                align: 'right',
                render: (col, row) => `${utils.currency(row.importe_ct)}`,
            }
        ],
    }

    async componentDidMount() {
        this.fetch();
    }

    fetch = async (params = {}) => {
        try {

            const responseCB = await api.cuentas_bancarias.getAll();
            if (responseCB.status === "success") {
                this.setState({
                    cuentas_bancarias: responseCB.data.cuentas
                })
            }

            //CONCEPTOS VALES
            const responseVales = await api.vales.getAll(queryString.stringify({
                query: '',
            }))
            if (responseVales.status === "success") {
                this.setState({
                    vales: responseVales.data.conceptos,
                });
            } else {
                this.setState({
                    vales: [],
                });
                message.error(responseVales.message, 5);
            }

            const response = await api.adelantos.get(this.props.match.params.id);
            // console.log("response: ", response);

            const found = this.state.vales.find(item => item.codigocval === response.data.codtipvaad);
            let conceptovale = found && found.descricval ? found.descricval : ''
            this.setState({ ...response.data, conceptovale, chofer: response.data.nombrechof });
        } catch (e) {
            message.error(e.toString(), 7);
        }
    }

    handleLocalidades = async (value) => {

        this.setState({
            localidades: null,
        })
        if (value.trim().length >= 3) {
            try {
                this.setState({ fetchingLocalidad: true });
                const response = await api.localidades.getAll(queryString.stringify({
                    query: value.trim(),
                }))

                this.setState({
                    autoCompleteLocalidades: response.data.localidades ? response.data.localidades.map((data, index) => {
                        return {
                            text: `${data.nombrlocal} - ${data.nombrepcia}`,
                            value: `${data.codiglocal}`,
                        }
                    }) : [],
                    fetchingLocalidad: false,
                });

            } catch (e) {
                message.error(e.toString(), 7);
            }
        } else if (value.trim().length === 0) {
            this.setState({ autoCompleteLocalidades: [] })
        }
    }

    onSelectLoc(e) {
        this.setState({ localidad: e })
    }

    doc = async (e, tipo) => {
        if (tipo === "n1") {
            this.props.form.setFieldsValue({
                nucuilchof: e.target.value,
            })
            this.setState({ n1: e.target.value })
        } else if (tipo === "n2") {
            this.props.form.setFieldsValue({
                nucuilchof: `${this.state.n1}-${e.target.value}-${this.state.n3}`,
            })
            this.setState({ n2: `${this.state.n1}-${e.target.value}`, nro: `${this.state.n1}-${e.target.value}-${this.state.n3}` })
        } else if (tipo === "n3") {
            this.props.form.setFieldsValue({
                nucuilchof: `${this.state.n2}-${e.target.value}`,
            })
            this.setState({ n3: e.target.value })
        }
    }

    next() {
        this.props.form.validateFields(['fecha_vaad', 'codtipvaad', 'cchofevaad', 'importvaad'], (err, values) => {
            if (!err) {
                const current = this.state.current + 1;
                this.setState({ current });
            }
        })

    }

    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
        // this.props.form.setFieldsValue({
        //     fecha_vaad: moment.parseZone(this.state.fecha_vaad),
        //     codtipvaad: this.state.codtipvaad,
        //     cchofevaad: this.state.cchofevaad,
        //     importvaad: this.state.importvaad,
        //     nufactvaad: this.state.nufactvaad,
        //     concepto: this.state.concepto,
        // })
    }

    bco = async (data) => {
        const datos = this.state.bancos && this.state.bancos.map((bancos, index) => {
            if (data === bancos.codigo_bco) {
                this.setState({
                    banco: bancos
                })
                this.props.form.setFieldsValue({
                    nucta_cp: bancos.numerocta
                })
            }
        })
        this.props.form.setFieldsValue({
            nprovee_cp: this.props.fletero ? this.props.fletero.rasociflet : '',
        })
    }

    cargarfpago = async (id) => {
        this.state.fpago.map((data, index) => {
            if (id === data.codigofpag) {
                this.setState({ formapago: data })
                if (data.codigofpag == "2") {
                    this.props.form.setFieldsValue({
                        nprovee_cp: this.state.proveedor && this.state.proveedor.rasociprov,
                    })
                }
            }
        })
    }

    borrar = (row, index) => {
        var newdata = []
        var newcheque = []
        var rowSelection2 = []
        var importe = 0
        var dif = 0.00
        var chequesTerceros = this.state.chequesT
        try {
            this.state.data1.map((data, i) => {
                if (i !== index) {
                    newdata.push(data)
                }
            })
            this.setState({ data1: newdata })
            var importe = 0
            newdata.map((data) => {
                importe = importe + data.importetot
            })

            if (this.state.acancelar <= this.state.apagar) {
                dif = this.state.apagar - importe
            }
            this.setState({ totalimporte: importe, acancelar: dif })


            if (row.tipo != "T") {
                const found = this.state.cheques.findIndex(item => row.num_cupon == `${item.nombco_cp}-${item.nuseri_cp}-${item.numero_cp}`);
                if (found >= 0) {
                    this.state.cheques.map((data, indes) => {
                        if (found !== indes) {
                            newcheque.push(data)
                        }
                    })
                    this.setState({ cheques: newcheque })
                }
            } else {
                this.setState({ loading2: true, chequesT: [] });
                const found = this.state.chequesT.findIndex(item => row.num_cupon == `${item.nombco_ct}-${item.nuseri_ct}-${item.numero_ct}`);
                this.state.chequesT.map((data, indes) => {
                    if (found !== indes) {
                        rowSelection2.push(data)
                    }
                })
                setTimeout(() => {
                    this.setState({
                        loading2: false,
                        chequesT: chequesTerceros
                    });
                }, 700);
                // this.onSelectChange2(rowSelection2)
            }
        } catch (error) {
            message.error(error)
        }
    }

    borrarcheque = (row, index) => {
        var newdata = []
        var newcheque = []
        var importe = 0
        try {
            this.state.cheques.map((data, i) => {
                if (i !== index) {
                    newcheque.push(data)
                }
            })
            const found = this.state.data1.findIndex(item => item.num_cupon == `${row.nombco_cp}-${row.nuseri_cp}-${row.numero_cp}`);
            this.state.data1.map((data, indes) => {
                if (found !== indes) {
                    newdata.push(data)
                }
            })

            this.setState({ cheques: newcheque, data1: newdata })
            var importe = 0
            var dif = 0.00
            newdata.map((data) => {
                importe = importe + data.importetot
            })
            if (this.state.acancelar <= this.state.apagar) {
                dif = this.state.apagar - importe
            }
            this.setState({ totalimporte: importe, acancelar: dif })
            this.setState({ totalimporte: importe })
        } catch (error) {
            message.error(error)
        }
    }

    handleAgregarCheque = async () => {
        if (this.state.concepto_cheque && this.state.data1.length > 0) {
            return this.getMessage()
        }
        this.props.form.validateFields(['feemi_cp', 'fecobro_cp', 'nuseri_cp', 'nucta_cp', 'numero_cp', 'cuitemi_cp', 'nombco_cp', 'sucursa_cp', 'nprovee_cp', 'importe_cp'], (err, values) => {
            if (!err) {
                try {
                    this.state.cheques.push({
                        feemi_cp: moment.parseZone(values.feemi_cp).format("DD/MM/YYYY"),
                        fecobro_cp: moment.parseZone(values.fecobro_cp).format("DD/MM/YYYY"),
                        codbco_cp: this.state.banco.codigo_bco,
                        nombco_cp: this.state.banco.nombre_bco,
                        nuseri_cp: values.nuseri_cp,
                        nucta_cp: values.nucta_cp,
                        numero_cp: values.numero_cp,
                        nprovee_cp: values.nprovee_cp,
                        importe_cp: values.importe_cp,
                    })
                    this.state.data1.push({
                        codforpago: this.state.formapago.codigofpag,
                        desforpago: this.state.formapago.descrifpag,
                        num_cupon: `${this.state.banco.nombre_bco}-${values.nuseri_cp}-${values.numero_cp}`,
                        importetot: values.importe_cp,
                        tipo: "",
                    })
                } catch (error) {
                    message.error(error)
                } finally {
                    this.props.form.setFieldsValue({
                        feemi_cp: '',
                        fecobro_cp: '',
                        nuseri_cp: '',
                        nucta_cp: '',
                        numero_cp: '',
                        cuitemi_cp: '',
                        nombco_cp: '',
                        sucursa_cp: '',
                        nprovee_cp: '',
                        codforpago: '',
                        importe_cp: '',
                    })
                    this.setState({ formapago: "" })
                    this.importetotal()
                }
            }
        })
    }

    getMessage() {
        return Modal.info({
            title: "No se puede agregar otra forma de pago en este adelanto",
            content: '',
            onOk: () => { }
        })
    }

    importetotal = () => {
        var importe = 0.00
        var dif = 0.00
        this.state.data1.map((data) => {
            importe = (importe + parseFloat(data.importetot))
        })
        if (this.state.acancelar <= this.state.apagar) {
            dif = this.state.apagar - importe
        }
        this.setState({ apagar: importe, acancelar: dif })
    }


    modalConfirm = () => {
        const _this = this
        Modal.confirm({
            title: 'Atención',
            content: '¿Emitir liquidación?',
            okText: 'Emitir',
            icon: 'info-circle',
            cancelText: 'Cancelar',
            async onOk() {
                _this.facturar();
            },
        });
    }

    facturar = async (e) => {
        this.props.form.validateFields(["fecha_vaad", "codtipvaad", "cchofevaad",], async (err, values) => {
            if (!err) {
                try {
                    this.setState({
                        confirmLoading: true,
                    })
                    let concepto = this.state.conceptovale.descricval
                    if (this.state.concepto_cheque) {
                        concepto += " " + this.state.data1[0].num_cupon
                    }
                    // console.log("CREATE: => ", {...values,
                    //     nufactvaad: this.state.nufactvaad,
                    //     importvaad: this.state.apagar,
                    //     cprovevaad: "0",
                    //     fecha_vaad: moment.parseZone(values.fecha_vaad).format("DD/MM/YYYY"),
                    //     ctransvaad: this.props.fleteros_id,
                    //     ntransvaad: this.props.fletero && this.props.fletero.rasociflet, // nombre fletero
                    //     concepto,
                    //     valores: this.state.data1,
                    //     chequesP: this.state.cheques,
                    //     chequesT: this.state.chequesT,})
                    const response = await api.adelantos.create({
                        ...values,
                        nufactvaad: this.state.nufactvaad,
                        importvaad: this.state.apagar,
                        cprovevaad: "0",
                        fecha_vaad: moment.parseZone(values.fecha_vaad).format("DD/MM/YYYY"),
                        ctransvaad: this.props.fleteros_id,
                        ntransvaad: this.props.fletero && this.props.fletero.rasociflet, // nombre fletero
                        concepto,
                        valores: this.state.data1,
                        chequesP: this.state.cheques,
                        chequesT: this.state.chequesT,
                        idusuario: this.props.user ? this.props.user.codigoempl : null,
                    })
                    if (response.status === "success") {
                        // this.props.history.push("/app/proveedor/detalle/liquidacion/" + response.idLiquidacion)
                        this.props.closeModal()
                    } else {
                        message.error(response.message, 7);
                    }
                } catch (e) {
                    message.error(e.toString(), 7);
                } finally {
                    this.setState({
                        confirmLoading: false,
                    })
                }
            } else {
                message.error("Hay algunos campos vacíos, por favor revisar si están correctos")
            }
        })
    }

    conceptovale = async (e) => {
        const { CONCEPTOS_VALES } = this.state;
        this.state.vales && this.state.vales.map((data) => {
            if (e == data.codigocval) {
                this.setState({ conceptovale: data })
                if (e == CONCEPTOS_VALES.CHEQUESPROPIOS || e == CONCEPTOS_VALES.CHEQUESTERCEROS) {
                    this.setState({ concepto_cheque: true })
                }
            }
        })
    }

    imprimirheques = async (codigo_bco) => {
        const file = await api.adelantos.imprimirCheques(this.props.match.params.id, codigo_bco, 'application/pdf');
        var fr = new FileReader();
        fr.readAsDataURL(file);
        var blob = new Blob([file], { type: "application/pdf" });
        var objectURL = window.URL.createObjectURL(blob);
        // eslint-disable-next-line
        var link = document.createElement('a');
        window.open(objectURL)
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <section className="form-v1-container col-md-12">
                <QueueAnim type="bottom" className="ui-animate">
                    <Breadcrumb>
                        <Breadcrumb.Item href='#'>Inicio</Breadcrumb.Item>
                        <Breadcrumb.Item>Adelantos</Breadcrumb.Item>
                        <Breadcrumb.Item>{this.props.match.params.id}</Breadcrumb.Item>
                    </Breadcrumb>

                    <div className="box box-default box-ant-table-v1" style={{ marginTop: 15 }}>
                        <div className="box-body">
                            <PageHeader
                                title="Detalle Adelanto"
                                onBack={() => this.props.history.goBack()}
                                // extra={[
                                //     <Dropdown trigger={['click']} overlay={
                                //         <Menu>
                                //             {this.state.cuentas_bancarias && this.state.cuentas_bancarias.map((data, index) => {
                                //                 return (
                                //                     <Menu.Item key={index} onClick={() => this.imprimirheques(data.codigo_bco)}>
                                //                         BANCO {data.nombre_bco}
                                //                     </Menu.Item>
                                //                 )
                                //             })}
                                //         </Menu>
                                //     }>
                                //         <Button>
                                //             <i className="fas fa-print" style={{ marginTop: 5, marginRight: 5 }}></i>
                                //             Imprimir Cheques
                                //         </Button>
                                //     </Dropdown>,
                                // ]}
                            />

                            <Divider />
                            <Form style={{ marginTop: 10 }}>
                                <div>
                                    <Row gutter={8} >
                                        <Col span={24}>
                                            <FormItem label="Fecha" {...{
                                                labelCol: { sm: { span: 4 }, },
                                                wrapperCol: { sm: { span: 3 }, },
                                            }}>
                                                {getFieldDecorator('fecha_vaad', {
                                                    initialValue: this.state.fecha_vaad ? this.state.fecha_vaad : '',
                                                    rules: [{ required: true, message: "Fecha es obligatorio" }],
                                                })(
                                                    <Input readOnly />
                                                )}
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8} >
                                        <Col span={24}>
                                            <FormItem label="Concepto vales" {...{
                                                labelCol: { sm: { span: 4 }, },
                                                wrapperCol: { sm: { span: 14 }, },
                                            }}>
                                                {getFieldDecorator('codtipvaad', {
                                                    initialValue: this.state.conceptovale && this.state.conceptovale,
                                                    rules: [{ required: true, message: "Este campo es requerido" }],
                                                })(
                                                    <Input readOnly />
                                                )}
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8} >
                                        <Col span={12}>
                                            <FormItem label="Chofer" {...{
                                                labelCol: { sm: { span: 8 }, },
                                                wrapperCol: { sm: { span: 16 }, },
                                            }}>
                                                {getFieldDecorator('cchofevaad', {
                                                    initialValue: this.state.chofer && this.state.chofer,
                                                    rules: [{ required: true, message: "Este campo es requerido" }],
                                                })(
                                                    <Input readOnly />
                                                )}
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8} >
                                        <Col span={24}>
                                            <FormItem label="N° Factura" {...{
                                                labelCol: { sm: { span: 4 }, },
                                                wrapperCol: { sm: { span: 14 }, },
                                            }}>
                                                {getFieldDecorator('nufactvaad', {
                                                    initialValue: this.state.nufactvaad && this.state.nufactvaad,
                                                    rules: [{ required: false, message: "Este campo es requerido" }],
                                                })(
                                                    <Input readOnly />
                                                )}
                                            </FormItem>
                                        </Col>
                                        <Col span={24}>
                                            <FormItem label="Concepto" {...{
                                                labelCol: { sm: { span: 4 }, },
                                                wrapperCol: { sm: { span: 14 }, },
                                            }}>
                                                {getFieldDecorator('concepto', {
                                                    initialValue: this.state.concepto && this.state.concepto,
                                                    rules: [{ required: false, message: "Este campo es requerido" }],
                                                })(
                                                    <Input.TextArea rows={2} readOnly />
                                                )}
                                            </FormItem>
                                        </Col>

                                        <Col span={24}>
                                            <FormItem label="Total" {...{
                                                labelCol: { sm: { span: 4 }, },
                                                wrapperCol: { sm: { span: 3 }, },
                                            }}>
                                                {getFieldDecorator('importvaad', {
                                                    initialValue: this.state.importvaad ? '$ ' + this.state.importvaad : 0,
                                                    rules: [{ required: false, message: "Este campo es requerido" }],
                                                })(
                                                    <Input readOnly />
                                                )}
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </div>

                                <Divider />
                                <div>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <h4 style={{ fontWeight: 'bold' }}>Cheques propios</h4>
                                        </Col>
                                        <Col span={24}>
                                            <Table
                                                pagination={false}
                                                style={{ fontSize: '8px' }}
                                                columns={this.state.columnsC}
                                                rowKey={(record, index) => index}
                                                dataSource={this.state.cheques_propios}
                                                loading={this.state.loading}
                                            />
                                        </Col>
                                    </Row>
                                    <Divider></Divider>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <h4 style={{ fontWeight: 'bold' }}>Cheques terceros</h4>
                                        </Col>
                                        <Col span={24}>
                                            <Table
                                                pagination={false}
                                                style={{ fontSize: '8px' }}
                                                columns={this.state.columnsCT}
                                                rowKey={(record, index) => record}
                                                dataSource={this.state.cheques_terceros}
                                                loading={this.state.loading2}
                                            />
                                        </Col>
                                    </Row>
                                    <br />
                                </div>
                            </Form>
                        </div>
                    </div>
                </QueueAnim>
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const WrappedDetalle = Form.create()(Detalle);

export default connect(
    mapStateToProps,
)(WrappedDetalle);